module.exports = {
    //baseUrl: 'https://customerapi.livefacetof.com', // 正式项目地址
    // wsurl: 'wss://customerapi.livefacetof.com/staff',
    baseUrl: 'https://fcball-imapi.jinkunzs.com',
    wsurl: 'wss://fcball-imapi.jinkunzs.com/staff',
}